@if (rehearsal) {
  <div class="summary-container">
    <!-- Header with date (optional) -->
    @if (showHeader) {
      <div class="summary-header">
        <ion-icon name="calendar-outline"></ion-icon>
        <span>{{ rehearsal.performance?.datetime | readableDateTime: 'date' }}</span>
      </div>
    }

    <!-- Person Name -->
    @if (rehearsal.personName) {
      <div class="summary-section">
        <div class="section-label">Ingevuld door</div>
        <div class="section-content">{{ rehearsal.personName }}</div>
      </div>
    }

    <!-- Purpose -->
    @if (rehearsal.purpose) {
      <div class="summary-section">
        <div class="section-label">Repetitie voor</div>
        <div class="section-content">{{ rehearsal.purpose }}</div>
      </div>
    }

    <!-- Notes -->
    @if (rehearsal.notes) {
      <div class="summary-section">
        <div class="section-label">Opmerkingen</div>
        <div class="section-content notes">{{ rehearsal.notes }}</div>
      </div>
    }

    <!-- Scenes -->
    @if (rehearsal.scenes?.length > 0) {
      <div class="summary-section">
        <div class="section-label">Scènes</div>
        <div class="scenes-list">
          @for (scene of rehearsal.scenes; track scene.id) {
            <div class="scene-item">
              <div class="scene-name">{{ scene.name }}</div>
              @if (scene.notes) {
                <div class="scene-notes">{{ scene.notes }}</div>
              }
              @if (hasRequiredItems(scene)) {
                <div class="scene-items">
                  @for (item of scene.items; track item.id) {
                    @if (item.required) {
                      <span class="item-chip">{{ item.name }}</span>
                    }
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    <!-- Copy Button -->
    <div class="copy-section">
      <ion-button expand="block" color="primary" (click)="copyToClipboard()">
        <ion-icon slot="start" name="copy-outline"></ion-icon>
        {{ copyButtonText }}
      </ion-button>

      <details class="copy-preview">
        <summary>Bekijk tekst samenvatting</summary>
        <pre class="copy-text">{{ formatForWhatsApp() }}</pre>
      </details>
    </div>
  </div>
} @else {
  <div class="empty-state">
    <ion-icon name="document-text-outline"></ion-icon>
    <p>Geen repetitie gegevens beschikbaar.</p>
  </div>
}
